import { useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { useNavigate } from "react-router";

import { usePostSignIn } from "@/hooks/queries/usePostSignIn";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { storage } from "@/lib/storage";

export const PostSignInPage = () => {
  const navigate = useNavigate();
  const { data, status } = usePostSignIn();

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.POST_SIGN_IN);
  }, []);

  useEffect(() => {
    if (status === "success") {
      // Put the sign-in response in storage (access token, refresh token, etc.).
      storage.setUser(data);

      try {
        // Set the user properties in Mixpanel. This generally mirrors the implementation on the talent side.
        mixpanel.identify(data.id.toString());
        mixpanel.people.set({
          $email: data.email,
          $first_name: data.firstName,
          $last_name: data.lastName,
        });
      } catch {
        // Do nothing!
      } finally {
        // Redirect the signed-in user to the home page.
        void navigate("/");
      }
    }
  }, [data, navigate, status]);

  // TODO: Add a loading state.
  return null;
};
